import * as yup from "yup";

/**
 * Server-side filters for GET accounts/v1 (Brands list).
 *
 * `country` is a single value matched server-side as a case-insensitive
 * regex against the account's country field (confirmed against backend-srv's
 * `listAccountsQuerySchema` / `buildAccountFilter`) — the backend has no
 * multi-country ("IN") support, so this is single-select only.
 *
 * `debit_note_frequency` and `kyc_status` are intentionally not included yet
 * — not wired up on the UI/API side for this pass.
 */
export const brandFiltersSchema = yup.object({
    country      : yup.string().trim().default(""),
    platform_name: yup.string().trim().default(""),
    payment_model: yup.string().trim().default("")
});

export const defaultBrandFilters = brandFiltersSchema.getDefault();

/**
 * Validates the current filter state and converts it into axios `params`,
 * dropping anything empty so we don't send `country=&platform_name=`.
 */
export const toBrandFilterParams = async (filters) => {
    const validated = await brandFiltersSchema.validate(filters, { stripUnknown: true });

    const params = {};
    if (validated.country) params.country = validated.country;
    if (validated.platform_name) params.platform_name = validated.platform_name;
    if (validated.payment_model) params.payment_model = validated.payment_model;

    return params;
};

